"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const context_1 = require("../../../context");
const reusables_1 = require("../../../comps/reusables");
const CreateResourcesButton_1 = require("../../../comps/reusables/CreateResourcesButton");
const react_2 = require("@osmosys/react");
const svg_1 = require("../../../svg");
const constants_1 = require("../../../constants");
const graphql_1 = require("../../../graphql");
const CreateIntegrationDetail_1 = require("./CreateIntegrationDetail");
const react_hanger_1 = require("react-hanger");
exports.IntegrationsList = () => {
    const { state, setState } = react_hanger_1.useSetState({
        addIntegrationType: null,
    });
    return (react_1.default.createElement(react_2.OsmosysListLayout, { pathToCount: "integrationsCount", pathToItems: "integrations", query: {
            query: graphql_1.integrations,
            variables: {},
        }, itemName: "integration", itemsName: "integrations", toolbarLeft: () => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ currentUser }) => {
                    const filteredIntegrations = constants_1.INTEGRATION_OPTIONS.filter(itg => !!currentUser.currentWorkspaceMembership.workspace.enabledIntegrationClasses.includes(itg.value));
                    if (filteredIntegrations.length === 0) {
                        return (react_1.default.createElement("p", { className: "my-1 text-muted" },
                            "Please",
                            ' ',
                            react_1.default.createElement("a", { href: "mailto:support@yellowbrim.com" }, "contact support"),
                            ' ',
                            "to activate integrations for your workspace."));
                    }
                    return (react_1.default.createElement(CreateResourcesButton_1.CreateResourcesButton, { label: "New integration", options: filteredIntegrations, onSelect: integrationType => {
                            setState({
                                addIntegrationType: {
                                    name: integrationType.label,
                                    type: integrationType.value,
                                },
                            });
                        } }));
                }),
                react_1.default.createElement(CreateIntegrationDetail_1.CreateIntegrationDetail, { isOpen: !!state.addIntegrationType, integrationType: state.addIntegrationType, onClose: () => {
                        setState({
                            addIntegrationType: null,
                        });
                    } })));
        }, showReloadButton: true, itemProps: (item) => {
            const style = { height: 80, width: 80 };
            let connectBtn;
            let icon = react_1.default.createElement(svg_1.IntegrationsLogo, { style: style });
            if (item.integrationType === 'Salesforce') {
                icon = react_1.default.createElement(svg_1.SalesforceLogo, { style: style });
                connectBtn = (react_1.default.createElement(reusables_1.ConnectionStatus, { canConnect: item.canConnectToREST !==
                        item.canConnectToSOAP
                        ? 'partial'
                        : !!(item.canConnectToREST &&
                            item.canConnectToSOAP) }));
            }
            else if (item.integrationType === 'ActiveCampaign') {
                icon = react_1.default.createElement(svg_1.ActiveCampaignLogo, { style: style });
            }
            else if (item.integrationType === 'Mailjet') {
                icon = react_1.default.createElement(svg_1.MailjetLogo, { style: style });
            }
            else if (item.integrationType === 'Sailthru') {
                icon = react_1.default.createElement(svg_1.SailthruLogo, { style: style });
            }
            else if (item.integrationType === 'CampaignMonitor') {
                icon = react_1.default.createElement(svg_1.CampaignMonitorLogo, { style: style });
            }
            else if (item.integrationType === 'Mailchimp') {
                icon = react_1.default.createElement(svg_1.MailchimpLogo, { style: style });
            }
            if ([
                'Sailthru',
                'ActiveCampaign',
                'Mailjet',
                'CampaignMonitor',
                'Mailchimp',
            ].includes(item.integrationType)) {
                connectBtn = (react_1.default.createElement(reusables_1.ConnectionStatus, { canConnect: item.canConnect, connectedText: item.integrationType === 'Mailchimp'
                        ? item.dataCenter
                            ? `Connected to ${item.dataCenter}`
                            : 'Connected, but with unknown data center'
                        : 'Connected' }));
            }
            return {
                body: connectBtn && (react_1.default.createElement(react_1.default.Fragment, null,
                    connectBtn,
                    react_1.default.createElement("br", null))),
                icon,
                iconLabel: item.displayType ? item.displayType : 'Integration',
                linkURL: `/integrations/${item.id}`,
                meta: `Created ${moment_1.default(item.createdAt).format('LLL')}`,
                title: item.name,
            };
        } }, () => {
        return 'Integration';
    }));
};
exports.default = exports.IntegrationsList;
//# sourceMappingURL=index.js.map